import http from '@/utils/ajax'
import Router from '@/router'
import Vue from 'vue'
import { AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_FAIL, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_LOAD_DATA } from '@/store/types'
import { appID } from '@/const/underwriting'
import clone from 'clone'

export const quote = {
  async createQuote({ commit, state }, formData) {
    // Only use this for sales Opportunity Quote Creation
    const apiUrl = state.quotationSettings.menu.salesOppSave
    if (apiUrl) {
      commit(AGENCY_QUOTATION_SAVE_LOADING)
      try {
        const result = await http.post(apiUrl, formData)
        if (result.data) {
          const commitObject = {
            partialSave: false,
            data: result.data,
            query: false
          }
          commit(AGENCY_QUOTATION_LOAD_DATA, commitObject)
          // Redirect to specific Quotation Pagee
          if (formData.appID === appID.MOTOR) {
            Router.push({ name: 'motorQuote' })
          } else if (formData.appID === appID.TRAVEL) {
            Router.push({ name: 'travelQuote' })
          } else if (formData.appID === appID.FIRE) {
            Router.push({ name: 'fireQuote' })
          } else if (formData.appID === appID.PA) {
            Router.push({ name: 'paQuote' })
          } else if (formData.appID === appID.CARGO) {
            Router.push({ name: 'cargoQuote' })
          } else if (formData.appID === appID.PACKAGE) {
            Router.push({ name: 'packageQuote' })
          } else if (formData.appID === appID.MAID) {
            Router.push({ name: 'maidQuote' })
          } else {
            // Unknown module
            Vue.prototype.$snotify.error('Cannot find selected module')
          }
        }
        commit(AGENCY_QUOTATION_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(AGENCY_QUOTATION_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Fail to create Quotation']))
        }
      }
    } else {
      commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
    }
  },
  async saveQuote({ commit, state, getters }) {
    // Save quotation
    const apiUrl = state.quotation.menu.save
    if (apiUrl) {
      commit(AGENCY_QUOTATION_SAVE_LOADING)
      try {
        const submitForm = generateCurrentForm(state, getters)
        const result = await http.post(apiUrl, submitForm)
        if (result.data) {
          // Code use to simulate wait time
          // await new Promise(resolve => setTimeout(resolve, 3000))
          const commitObject = {
            partialSave: true,
            data: result.data,
            query: false
          }
          commit(AGENCY_QUOTATION_LOAD_DATA, commitObject)
        }
        commit(AGENCY_QUOTATION_SAVE_SUCCESS)
        Vue.prototype.$snotify.success('Record saved')
      } catch (error) {
        if (error.response && error.response.data) {
          commit(AGENCY_QUOTATION_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Fail to save Quotation/Proposal']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  },
  async ntuQuote({ commit, state, getters }) {
    const apiUrl = state.quotation.menu.ntu
    if (apiUrl) {
      commit(AGENCY_QUOTATION_SAVE_LOADING)
      try {
        const submitForm = {
          proposalNo: state.quotation.commonForm.proposalNo,
          revision: state.quotation.commonForm.revision,
          appID: state.quotation.commonForm.appID
        }
        await http.post(apiUrl, submitForm)

        commit(AGENCY_QUOTATION_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(AGENCY_QUOTATION_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Fail to update Quotation/Proposal Status to NTU']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  },
  async voidQuote({ commit, state, getters }) {
    const apiUrl = state.quotation.menu.void
    if (apiUrl) {
      commit(AGENCY_QUOTATION_SAVE_LOADING)
      try {
        const submitForm = {
          proposalNo: state.quotation.commonForm.proposalNo,
          revision: state.quotation.commonForm.revision,
          appID: state.quotation.commonForm.appID
        }
        await http.post(apiUrl, submitForm)

        commit(AGENCY_QUOTATION_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(AGENCY_QUOTATION_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Fail to update Quotation/Proposal Status to Void']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  }
}

/**
 * Use to compile object to submit for saving (specific modules)
 */
export const generateCurrentForm = (state, getters) => {
  let submitForm
  if (state.quotation.commonForm.appID === appID.MOTOR) {
    submitForm = generalMotorForm(state)
  } else if (state.quotation.commonForm.appID === appID.TRAVEL) {
    submitForm = generalTravelForm(state)
  } else if (state.quotation.commonForm.appID === appID.FIRE) {
    submitForm = generalFireForm(state)
  } else if (state.quotation.commonForm.appID === appID.PA) {
    submitForm = generalPAForm(state)
  } else if (state.quotation.commonForm.appID === appID.CARGO) {
    submitForm = generalCargoForm(state)
  } else if (state.quotation.commonForm.appID === appID.PACKAGE) {
    submitForm = generalPackageForm(state, getters)
  } else if (state.quotation.commonForm.appID === appID.MAID) {
    submitForm = generalMaidForm(state)
  } else {
    // Unknown module
    submitForm = clone(state.quotation.commonForm)
  }
  return submitForm
}

export const generalMotorForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.quotation.motorForm))
}
export const generalTravelForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.quotation.travelForm))
}
export const generalFireForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.quotation.fireForm))
}
export const generalPAForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.quotation.paForm))
}
export const generalCargoForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.quotation.cargoForm))
}
export const generalPackageForm = (state, getters) => {
  let result = Object.assign({}, compileCommonForm(state), clone(state.quotation.packageForm))
  const selectedPlan = getters.packageQuoteSelectedPlan
  if (selectedPlan && selectedPlan.appIDs && selectedPlan.appIDs.length > 0) {
    if (selectedPlan.appIDs.find(x => x === 'FI')) {
      const { fireForm } = state.quotation
      Object.assign(result, {
        riskAdd: fireForm.riskAdd,
        riskAdd1: fireForm.riskAdd1,
        riskAdd2: fireForm.riskAdd2,
        riskAdd3: fireForm.riskAdd3,
        riskAdd4: fireForm.riskAdd4,
        riskPostalCode: fireForm.riskPostalCode
      })
    }
  }
  return result
}
export const generalMaidForm = (state) => {
  return Object.assign({}, compileCommonForm(state), clone(state.quotation.maidForm))
}
function compileCommonForm(state) {
  // Compile it into a format that sync with the backend
  const cloneCommonForm = clone(state.quotation.commonForm)
  let result = Object.assign({}, cloneCommonForm, clone(cloneCommonForm.applicant))
  delete result['applicant']
  return result
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
